import AffiliateLink from "./AffiliateLink";

export default AffiliateLink;
